'use client';

import Link from 'next/link';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import curriculum from '@/src/data/curriculum.json';

interface ModuleNavigationProps {
  currentModuleId: string;
}

export function ModuleNavigation({ currentModuleId }: ModuleNavigationProps) {
  const modules: string[] = (curriculum as { modules?: string[] }).modules || [];
  const currentIndex = modules.indexOf(currentModuleId);

  if (currentIndex === -1) {
    return null; // Module not found in curriculum
  }

  const prevModuleId = currentIndex > 0 ? modules[currentIndex - 1] : null;
  const nextModuleId = currentIndex < modules.length - 1 ? modules[currentIndex + 1] : null;

  if (!prevModuleId && !nextModuleId) {
    return null; // No navigation needed
  }

  return (
    <nav
      className="flex items-center justify-between gap-4 pt-6 sm:pt-8 border-t border-border"
      aria-label="Module navigation"
    >
      {prevModuleId ? (
        <Button asChild variant="outline" className="flex items-center gap-2">
          <Link href={`/modules/${prevModuleId}`}>
            <ChevronLeft className="h-4 w-4" />
            Previous Module
          </Link>
        </Button>
      ) : (
        <div /> // Spacer
      )}
      {nextModuleId ? (
        <Button asChild variant="outline" className="flex items-center gap-2">
          <Link href={`/modules/${nextModuleId}`}>
            Next Module
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>
      ) : (
        <div /> // Spacer
      )}
    </nav>
  );
}
